var map = {
	"./asyncData.js": 14065,
	"./carts.js": 99083,
	"./chat.js": 87838,
	"./config.js": 52755,
	"./crudList.js": 27416,
	"./currency.js": 43683,
	"./locale.js": 49641,
	"./something.js": 89823,
	"./ui.js": 59662,
	"./user.js": 95801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96440;